import React, { useMemo, useCallback } from "react";
import ModulePreview from "../ModulePreview";

export default React.memo(() => {
	const defaultSurveyData = useMemo(
		() => ({
			survey_question: {
				is_default: false,
				options: [
					{
						extra_text: "",
						follow_text: null,
						icon_url:
							"https://coopcommerce.s3-us-west-1.amazonaws.com/option_color.png",
						text: "Your survey option",
						text_input: false,
					},
				],
				question_text: "Your survey question",
			},
		}),
		[]
	);

	const surveyDataMapper = useCallback(
		(requestData, initData) => ({
			...(requestData?.survey_question?.options?.length > 0
				? requestData.survey_question
				: initData.survey_question),
		}),
		[]
	);

	return (
		<ModulePreview
			moduleType="survey"
			remoteKey="survey_question"
			defaultData={defaultSurveyData}
			moduleDataMapper={surveyDataMapper}
		/>
	);
});
